export default __webpack_public_path__ + "static/media/glitch30.a21aac45.png";